<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <div class="row" v-if="enable_error_list">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="alert alert-danger">
                    <ol>
                        <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                    </ol>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xl-7 col-md-7 col-xs-12 col-sm-12 mt-1">
                <div class="col-xl-7 col-md-7 col-xs-12 col-sm-12 mt-1">
                    <router-link to="/notification-client/new" class="btn btn-info"><i class="fa fa-plus"></i> Adicionar
                        notificação</router-link>
                </div>
            </div>
            <div class="col-xl-2 col-md-2 col-xs-12 col-sm-12 offset-xl-3 offset-md-3  mt-1 ">
                <div class="wrapper input-group">

                    <button class="btn btn-light ml-2 " @click="advancedSearch()"><i class="fa fa-align-justify"></i>
                        Busca avançada</button>
                </div>
            </div>
        </div>
        <div class="row mt-3" v-show="advanced_search">
            <div class="col-xl-12 col-md-12 col-xs-12 col-sm-12">
                <fieldset>
                    <div class="row">
                        <div class="col-xl-12 col-md-12 col-xs-12 col-sm-12">
                            <label for="">Descrição</label>
                            <input type="text" id="description" class="form-control"
                                placeholder="Ex: Solicitação extrato mensal" v-model="advanced_search_input.name">
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-xl-12 col-md-12 col-xs-12 col-sm-12">
                            <button class="btn btn-info" @click="executeAdvancedSearch()"> <i
                                    class="fas fa-search fa-sm"></i> Pesquisar</button>
                            <button class="btn btn-danger ml-2" @click="cleanAdvancedSearch()"> <i
                                    class="fas fa-times fa-sm"></i> Limpar</button>
                        </div>

                    </div>
                </fieldset>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="card shadow mb-4">
                    <!-- Card Header - Dropdown -->
                    <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                        <h6 class="m-0 font-weight-bold text-primary">Notificações clientes</h6> <button
                            class="btn btn-warning btn-sm" @click="loadData()"><i class="fa fa-undo"></i> Recarregar
                            dados</button>
                    </div>
                    <div class="card-body" :class="notifications.length <= 0 ? 'card-body-no-spaccing' : ''">
                        <div class="table-responsive">
                            <table class="table" id="dataTable" width="100%" cellspacing="0">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Título</th>
                                        <th class="text-center">Data notificação</th>
                                        <th class="text-center">Status</th>
                                        <th class="text-center">Repetir</th>
                                        <th class="text-center">Dia repetição</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(notification, index) in notifications" :key="notification.id">
                                        <td class="pointer" @click="openModalViewNotification(notification)">{{ index +
                                            1 }}</td>
                                        <td class="pointer" @click="openModalViewNotification(notification)">
                                            {{ notification.title }} </td>
                                        <td class="pointer text-center"
                                            @click="openModalViewNotification(notification)">{{
                                                notification.deadline_formatted }}
                                            às {{ notification.time_formatted }}</td>
                                        <td class="text-center"><span
                                                :class="notification.status == 'pending' ? 'badge badge-warning' : 'badge badge-success'"><i
                                                    :class="notification.status == 'pending' ? 'fa fa-spinner' : 'fa fa-check'"></i>
                                                {{
                                                    notification.status == 'pending' ? 'Pendente' : 'Finalizada' }}</span>
                                        </td>
                                        <td class="text-center">{{ notification.repeat ? 'Sim' : 'Não' }}</td>
                                        <td class="text-center">{{ notification.repeat ? notification.day_repeat : '-'
                                        }}</td>
                                        <td>
                                            <div class="dropdown">
                                                <button class="btn btn-primary dropdown-toggle" type="button"
                                                    id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                                    aria-expanded="false">
                                                    Ações
                                                </button>
                                                <div class="dropdown-menu animated--fade-in"
                                                    aria-labelledby="dropdownMenuButton">
                                                    <button class="dropdown-item"
                                                        @click="openModalViewNotification(notification)"> {{
                                                        notification.status == 'pending'?'Editar':'Detalhes' }}</button>
                                                    <button class="dropdown-item"
                                                        @click="openModalViewClientNotification(notification)">Lista de
                                                        clientes</button>
                                                    <button class="dropdown-item"
                                                        @click="openModalViewClientNotificationTest(notification)" v-if="notification.status == 'pending'"
                                                       >Enviar teste</button>
                                                    <button class="dropdown-item"
                                                        @click="deleteNotification(notification.id)"
                                                        v-if="notification.status == 'pending'">Excluir</button>
                                                </div>
                                            </div>
                                        </td>

                                    </tr>
                                    <tr v-if="notifications.length > 0 && page > 1">
                                        <td colspan="6" class="align-middle text-center pt-5"> <button
                                                @click="loadData()" class="btn btn-info btn-sm"
                                                :disabled="!buttonPagination"><i class="fa fa-spinner"></i> Carregar
                                                mais registros</button></td>
                                    </tr>
                                    <tr v-show="notifications.length <= 0">
                                        <td colspan="6" class="text-center">Nenhuma notificação encontrada</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div id="modalDisplayViewNotification" class="modal" :style="{ display: modalDisplayViewNotification }">
        <div class="row">
            <div class="col-lg-12 col-sm-12 col-xs-12">
                <form @submit="update">
                    <div class="modal-content">
                        <div class="row" v-if="enable_error_list">
                            <div class="col-xl-12 col-md-12 col-sm-12">
                                <div class="alert alert-danger">
                                    <ol>
                                        <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                        <div class="modal-header">
                            <h5 class="modal-title" id="newFileLabel">Atualizar notificação</h5>
                            <button type="button" class="close" @click="closeModalNotification()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-xl-3 col-md-3 col-sm-12">
                                    <label for="">Data notificação*</label>
                                    <input type="date" class="form-control" v-model="notification.deadline">
                                </div>
                                <div class="col-xl-3 col-md-3 col-sm-12">
                                    <label for="">Hora notificação*</label>
                                    <multiselect v-model="notification.time" :options="time_options"
                                        placeholder="Selecione uma opção" :select-label="'Clique para selecionar'"
                                        :deselect-label="'Clique para remover'">
                                        <template #noResult>
                                            Nenhum horário encontrado.
                                        </template>
                                    </multiselect>
                                </div>
                                <div class="col-xl-3 col-md-3 col-sm-12">
                                    <label for="">Repetir operação*</label>
                                    <div class="input-group mb-3">
                                        <multiselect v-model="repeat_multiselect" :options="repeat_options"
                                            placeholder="Selecione uma opção" :select-label="'Clique para selecionar'"
                                            :custom-label="repeatWithLang" :deselect-label="'Clique para remover'"
                                            @select="handleSelectRepeat">
                                            <template #noResult>
                                                Opção não encontrada.
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>
                                <div class="col-xl-3 col-md-3 col-sm-12" v-if="notification.repeat">
                                    <label for="">Dia mês para notificação*</label>
                                    <div class="input-group mb-3">
                                        <multiselect v-model="notification.day_repeat"
                                            :options="issuing_day_repeat_options" placeholder="Selecione uma opção"
                                            :select-label="'Clique para selecionar'"
                                            :deselect-label="'Clique para remover'" @select="handleSelectDayRepeat">
                                            <template #noResult>
                                                Nenhum dia encontrado.
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xl-12 col-md-12 col-sm-12">
                                    <label for="">Título*</label>
                                    <input type="text" class="form-control"
                                        placeholder="Ex: Aviso envio extrato bancário" v-model="notification.title">
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-xl-12 col-md-12 col-sm-12">
                                    <label for="">Descrição</label>
                                    <editorTextSimple @update-text="updateDescription"
                                        :modelValue="notification.description" placeholderSend="Solicitamos o envio...."
                                        ref="myChild">
                                    </editorTextSimple>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger"
                                @click="closeModalNotification()">Fechar</button>
                            <button type="submit" class="btn btn-info saveFile" :disabled='!isDisabled'
                                v-if="notification.status == 'pending'"><i class="fa fa-save"></i>
                                Atualizar</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <div id="modalDisplayViewClientNotification" class="modal" :style="{ display: modalDisplayViewClientNotification }">
        <div class="row">
            <div class="col-lg-12 col-sm-12 col-xs-12">
                <form @submit="updateListClient">
                    <div class="modal-content">
                        <div class="row" v-if="enable_error_list">
                            <div class="col-xl-12 col-md-12 col-sm-12">
                                <div class="alert alert-danger">
                                    <ol>
                                        <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                        <div class="modal-header">
                            <h5 class="modal-title" id="newFileLabel">Lista de clientes - {{ client_selected.length }}
                                registro(s)</h5>
                            <button type="button" class="close" @click="closeModalClientNotification()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row" v-if="notification.status == 'pending'">
                                <div class="col-xl-12 col-md-12 col-sm-12">
                                    <label for="">Selecione um ou mais clientes*</label>
                                    <multiselect v-model="client_multiselect" :options="clients_options"
                                        :custom-label="clientWithLang" placeholder="Selecione uma opção"
                                        @select="handleSelectClient">

                                        <template #noResult>
                                            Nenhum cliente encontrado.
                                        </template>
                                    </multiselect>
                                    <button type="button" class="btn btn-success mt-2" @click="addAllClientList"><i
                                            class="fa fa-check"></i>Adicionar
                                        todos os clientes</button>
                                    <button type="button" class="btn btn-danger mt-2 ml-2"
                                        @click="removeAllClientList"><i class="fa fa-ban"></i>
                                        Remover todos os
                                        clientes</button>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-xl-12 col-md-12 col-sm-12">
                                    <div class="table-responsive limitHeightListClient">
                                        <table class="table" id="dataTable" width="100%" cellspacing="0">
                                            <thead v-if="client_selected.length > 0">
                                                <tr>
                                                    <th>Documento</th>
                                                    <th>Nome</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(client, index) in client_selected" :key="index">
                                                    <td>{{ client.document }} </td>
                                                    <td>{{ client.name }} </td>
                                                    <td v-if="notification.status == 'pending'"><button type="button"
                                                            class="btn btn-danger"
                                                            @click="removeClientList(client.key)"><i
                                                                class="fa fa-trash"></i></button></td>
                                                </tr>
                                                <tr v-if="client_selected.length == 0">
                                                    <td class="text-center">Nenhum cliente selecionado</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger"
                                @click="closeModalClientNotification()">Fechar</button>
                            <button type="submit" class="btn btn-info saveFile" :disabled='!isDisabledListClient'
                                v-if="notification.status == 'pending'"><i class="fa fa-save"></i>
                                Atualizar</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <div id="modalDisplayViewClientNotificationTest" class="modal" :style="{ display: modalDisplayViewClientNotificationTest }">
        <div class="row">
            <div class="col-lg-12 col-sm-12 col-xs-12">
                <form @submit="sendTestNotification">
                    <div class="modal-content">
                        <div class="row" v-if="enable_error_list">
                            <div class="col-xl-12 col-md-12 col-sm-12">
                                <div class="alert alert-danger">
                                    <ol>
                                        <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                        <div class="modal-header">
                            <h5 class="modal-title" id="newFileLabel">Enviar notificação de teste</h5>
                            <button type="button" class="close" @click="closeModalClientNotificationTest()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-xl-12 col-md-12 col-sm-12">
                                   <label for="">E-mail</label>
                                   <input type="text" placeholder="usuario@dominio.com" class="form-control" v-model="notification.email">
                                </div>
                            </div>
                            
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger"
                                @click="closeModalClientNotificationTest()">Fechar</button>
                            <button type="submit" class="btn btn-info" :disabled='!isDisabledSendTestNotitication'
                                ><i class="fa fa-paper-plane"></i>
                                Enviar</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import Loading from 'vue-loading-overlay';
import editorTextSimple from '../util/editor-text-simple.vue';
import Multiselect from 'vue-multiselect'

import 'vue-loading-overlay/dist/css/index.css';

export default {
    components: { Loading, editorTextSimple, Multiselect },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            advanced_search: false,
            advanced_search_input: {},
            notifications: [],
            page: 1,
            last_page: 1,
            total_itens: 0,
            modalDisplayViewNotification: 'none',
            modalDisplayViewClientNotification: 'none',
            modalDisplayViewClientNotificationTest:'none',
            titleNotification: '',
            descriptionNotification: '',
            notification_by: '',
            readNotification: false,
            createdAtNotification: '',
            notification_id: 0,
            issuing_day_repeat_options: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28'],
            time_options: ['01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00', '24:00'],
            repeat_multiselect: '',
            repeat_options: [{ type: '1', value: 'Sim' }, { type: '0', value: 'Não' }],
            notification: {
                id: '',
                title: '',
                time: '',
                deadline: '',
                repeat: '',
                description: '',
                status: '',
                day_repeat: 1,
                email:''
            },
            clients_options: [],
            client_multiselect: '',
            clients: [],
            client_selected: []
        }
    },
    computed: {
        buttonPagination: function () {
            return this.page > 1;
        },
        isDisabled: function () {
            return this.notification.title != '' && this.notification.deadline != '' && this.notification.time != '';
        },
        isDisabledListClient: function () {
            return this.client_selected.length > 0;
        },
        isDisabledSendTestNotitication: function () {
            return this.notification.email != '';
        }


    },
    methods: {
        onCancel() { },
        advancedSearch() {
            this.advanced_search = !this.advanced_search
        },
        closeAdvancedSearch() {
            this.advanced_search = false
        },
        repeatWithLang({ value }) {
            return value;
        },

        handleSelectRepeat(option) {
            this.notification.repeat = option.type;
        },
        handleSelectDayRepeat(option) {
            this.notification.day_repeat = option;
        },
        handleSelectClient(option) {
            if (!this.inListClientSelected(option.key)) {
                this.client_selected.push({ 'key': option.key, 'document': option.document, 'name': option.name });
            }
            this.client_multiselect = '';


        },

        updateDescription(description) {
            this.notification.description = description;
        },
        executeAdvancedSearch() {
            this.page = 1;
            this.notifications = {};
            this.loadData();
        },
        cleanAdvancedSearch() {
            this.notifications = {}
            this.advanced_search_input = {}
            this.loadData();
        },
        loadData() {
            this.isLoading = true;
            api.get('/notification-client', {
                params: {
                    'page': this.page
                }
            })
                .then((response) => {
                    this.isLoading = false;
                    this.last_page = response.data.last_page;
                    if (this.page <= 1) {
                        this.notifications = response.data.data;
                    } else {
                        this.notifications = this.notifications.concat(response.data.data);
                    }

                    if (this.page < response.data.last_page) {
                        this.page++;
                    } else {
                        this.page = 1;
                    }

                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status);
                })
        },

        update(event) {
            event.preventDefault();
            this.isLoading = true;
            api.put('/notification-client/' + this.notification.id, this.notification)
                .then(() => {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Notificação atualizada com sucesso!",
                        type: 'success'
                    });
                    this.closeModalNotification();
                    this.loadData();
                }).catch(error => {
                    this.isLoading = false;
                    if (error.status == 422) {
                        let response_errors = error.response.data.errors;
                        this.errors = response_errors;
                        this.enable_error_list = true;
                    }
                    handleRequestErrors(error.status, error);
                })
        },

        updateListClient(event) {
            event.preventDefault();
            this.isLoading = true;
            let clients_selected = JSON.stringify(this.client_selected);
            const formData = new FormData();
            formData.append('clients', clients_selected);
            api.post('/notification-client/' + this.notification.id + '/clients', formData)
                .then(() => {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Lista de clientesatualizada com sucesso!",
                        type: 'success'
                    });
                    this.client_selected = [];
                    this.closeModalClientNotification();
                    this.loadData();
                }).catch(error => {
                    this.isLoading = false;
                    if (error.status == 422) {
                        let response_errors = error.response.data.errors;
                        this.errors = response_errors;
                        this.enable_error_list = true;
                    }
                    handleRequestErrors(error.status, error);
                })
        },

        removeClientList(element) {
            const index = this.client_selected.findIndex(item => item.key === element);
            if (index > -1) {
                this.client_selected.splice(index, 1);
            }

        },

          sendTestNotification(event) {
            event.preventDefault();
            this.isLoading = true;
            const formData = new FormData();
            formData.append('notification_id', this.notification.id);
            formData.append('email', this.notification.email);
            api.post('/notification-client/test', formData)
                .then(() => {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Notificação enviada com sucesso!",
                        type: 'success'
                    });
                    this.closeModalClientNotificationTest();
                    this.loadData();
                }).catch(error => {
                    this.isLoading = false;
                    if (error.status == 422) {
                        let response_errors = error.response.data.errors;
                        this.errors = response_errors;
                        this.enable_error_list = true;
                    }
                    handleRequestErrors(error.status, error);
                })
        },


        openModalViewNotification(notification) {
            this.notification.id = notification.id;
            this.notification.status = notification.status;
            this.notification.deadline = notification.deadline;
            this.notification.time = notification.time_formatted;
            this.notification.title = notification.title;
            this.notification.description = notification.description;
            this.notification.repeat = notification.repeat;
            this.notification.day_repeat = notification.day_repeat == '-' ? 1 : notification.day_repeat;
            this.$refs.myChild.updateTextEditor(this.notification.description);
            this.repeat_multiselect = notification.repeat ? { type: '1', value: 'Sim' } : { type: '0', value: 'Não' }
            this.modalDisplayViewNotification = 'block';
            this.isLoading = false;

        },
        closeModalNotification(value) {
            this.modalDisplayViewNotification = value;
        },

        openModalViewClientNotification(notification) {
            this.client_selected = [];
            this.notification.id = notification.id;
            let clients = notification.client;
            clients.map(client => (this.client_selected.push({ 'key': client.id, 'document': client.document_formatted, 'name': client.name })));
            this.notification.status = notification.status;
            this.modalDisplayViewClientNotification = 'block';
            this.isLoading = false;

        },
        closeModalClientNotification(value) {
            this.modalDisplayViewClientNotification = value;
        },


         openModalViewClientNotificationTest(notification) {
            this.notification.id = notification.id;
            this.modalDisplayViewClientNotificationTest = 'block';
            this.isLoading = false;

        },
        closeModalClientNotificationTest(value) {
            this.modalDisplayViewClientNotificationTest = value;
        },
        async getclients() {
            this.loading = true;
            const response = await api.get('/client', { params: { 'all_clientes': true, 'status': 'Ativo' } })
                .then((response) => {
                    this.clients = response.data.data;
                    this.loading = false;
                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                });
            return response;

        },

        inListClientSelected(key) {
            let inserted = false;
            this.client_selected.forEach(client => {
                if (client.key == key) {
                    inserted = true;
                }
            });
            return inserted;
        },

        clientWithLang({ value }) {
            return value;
        },

        addAllClientList() {
            this.client_selected = [];
            this.clients.map(client => (this.client_selected.push({ 'key': client.id, 'document': client.document_formatted, 'name': client.name })));
        },

        removeAllClientList() {
            this.client_selected = [];
        },

        deleteNotification(id) {
            this.$confirm(
                {
                    message: 'Deseja apagar a notificação?',
                    button: {
                        no: 'Não',
                        yes: 'Sim'
                    },

                    callback: confirm => {
                        if (confirm) {
                            this.isLoading = true;
                            api.delete('/notification-client/' + id)
                                .then(() => {
                                    this.isLoading = false;
                                    this.$notify({
                                        title: "Sucesso",
                                        text: "Noitificação excluída com sucesso",
                                        type: 'success'
                                    });
                                    this.page = 1;
                                    this.loadData();
                                }).catch(error => {
                                    this.isLoading = false;
                                    handleRequestErrors(error.status);
                                })
                        }
                    }
                }
            )
        }
},
mounted() {
    this.loadData();
    const response = this.getclients();
    response.then(() => {
        this.clients_options = this.clients.map(client => ({
            key: client.id,
            value: 'Documento: ' + client.document_formatted + '| Nome: ' + client.name,
            name: client.name,
            document: client.document_formatted
        }));
    });

},
}
</script>

<style>
.pointer {
    cursor: pointer;
}

.modal {
    position: fixed;
    z-index: 1999;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgb(0, 0, 0);
    background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
    background-color: #f5f5f5;
    margin: 3% auto;
    padding: 20px;
    border: 1px solid #888;
    width: 65%;
}

.modal-header {
    color: #000;
}

.close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
}

.close:hover,
.close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
}


@media (max-width: 576px) {
    .modal-content {
        width: 90% !important;
    }
}
</style>